import type { PsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import type { PsfComboQueryParamData } from '#src/app/shared/utils/bandits';

type PsfComboBanditData = {
	amount: number;
	currency: string;
	amountLocalized: string;
	amountId: string;
};

export function genPsfComboData(pageData: PsfPromoteOrSharePageData): PsfComboQueryParamData | undefined {
	const bandit = pageData.bandits.psfCombo;
	if (!bandit.variant) return undefined;
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const data = bandit.variant.data as unknown as PsfComboBanditData;
	return {
		experimentName: bandit.experimentName,
		variant: {
			variantName: bandit.variant.variantName,
			data: { amount: data.amount, amount_id: data.amountId },
			pulls: bandit.variant.pulls,
			rewards: bandit.variant.rewards,
		},
		variantName: bandit.variant.variantName,
		comboBanditAmount: pageData.chipInAmount,
		amountId: data.amountId,
	};
}
